/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enumeration of possible device sorting options.
 */
export enum DeviceSortBy {
    CODE = 'code',
    NAME_RO = 'nameRO',
    NAME_RU = 'nameRU',
}
